import React from 'react'
import MakeHomepage from '../make-homepage'

const MakeHomepageDa = () => {
    return <MakeHomepage languageCode="da" />
}

export default MakeHomepageDa
